import { error } from '@sveltejs/kit';

export async function load({ params, fetch }) {
    // Streamed (Async) data
    const reviews = fetch(`/api/reviews/${params.product}`)
        .then((r) => r.json()) // Transport JSON when SSR not full Response
        .catch((e) => console.error(e)); // Don't let the catch block run with json errors on the page

    // Blocking: Get main product data
    const productData = await fetch(`/api/products/${params.product}`);
    const productJson = await productData.json();
    const product = productJson?.product;

    if (!product) {
        error(404, {
            message: 'Product not found',
            code: 'NOT_FOUND_PRODUCT'
        });
    }

    // Stream recomendations now we have a product id; blocked by requests above
    const recomendations = productJson?.archived
        ? null
        : fetch(`/api/products/recommended/${encodeURIComponent(product?.id)}`)
              .then((r) => r.json()) // Transport JSON when SSR not full Response
              .catch((e) => console.error(e)); // Don't let the catch block run with json errors on the page;

    return { streamed: { reviews, recomendations }, product, cms: productJson?.cms, archived: productJson?.archived };
}
